export const JOB_OPP_LOADED = "JOB_OPP_LOADED";
export const JOB_OPP_CLEARED = "JOB_OPP_CLEARED";
export const JOB_OPPS_LOADING = "JOB_OPPS_LOADING";
export const JOB_OPPS_LOADED = "JOB_OPPS_LOADED";
export const JOB_TYPES_LOADED = "JOB_TYPES_LOADED";
export const COMPANY_NAMES_LOADED = "COMPANY_NAMES_LOADED";
export const COMPANY_FILTER_UPDATED = "COMPANY_FILTER_UPDATED";
export const JOB_TYPE_FILTER_UPDATED = "JOB_TYPE_FILTER_UPDATED";
export const JOB_FILTERS_CLEARED = "JOB_FILTERS_CLEARED";
